// extracted by mini-css-extract-plugin
export var fineArtSection = "fine_art-module--fineArtSection--Q04Lw";